import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-for-managers',
  imports: [RouterModule],
  templateUrl: './for-managers.component.html',
  styleUrl: './for-managers.component.css'
})
export class ForManagersComponent {

}
